import React from "react";
import { Helmet } from "react-helmet-async";
const PageMeta = ({ description, handle }) => {
    return (
        <Helmet>
            {description && <meta name="description" content={description} />}
            {handle && <link rel="canonical" href={`https://zoty.us${handle}`} />}
        </Helmet>
    )
}

export default PageMeta;